import React, { useState, useEffect, useLayoutEffect, useContext } from "react"
import { useStaticQuery, graphql, navigate, Link } from "gatsby"

import DesktopMenu from "./desktop-menu"
import MobileMenu from "./mobile-menu"

import { LangContext } from "../../context/LangContext"
import { useAuthContext } from "../../context/AuthContext"

import ImgNavbarLogoDark from "../../assets/img/brand/logo_bsd-dark.png"
import ImgNavbarLogoLight from "../../assets/img/brand/logo_bsd-light.png"
import { getDate } from "../../utils/get-date"

const sapKey = process.env.SAP_API_KEY

const Navbar = ({ newsSlug, isAmp, disableEffect }) => {
  const { lang, setLang } = useContext(LangContext)
  const [isGigyaReady, setIsGigyaReady] = useState(false);

  const data = useStaticQuery(graphql`
    query {
      wordPress {
        menus {
          nodes {
            name
            slug
            menuItems {
              nodes {
                url
                label
                childItems {
                  nodes {
                    label
                    url
                    childItems {
                      nodes {
                        label
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  useLayoutEffect(() => {
    // Check if script already exists
    const existingScript = document.querySelector(
      `script[src^="https://cdns.gigya.com/js/gigya.js"]`
    );
    if (existingScript) {
      return; // Script already loaded
    }
    const script = document.createElement("script");
    script.src = `https://cdns.gigya.com/js/gigya.js?apikey=${sapKey}`;
    script.async = true;
    document.head.appendChild(script);
    // Cleanup function
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [sapKey]);

  // Navbar expand config
  // Change the const below & config on _navbar.scss when setting the .navbar-expand-*
  // e.g. sm, md, lg, xl
  const navExpand = "lg"

  // Search - MOBILE
  // Open / close menu state & handler
  const [search, setSearch] = useState(false)
  const [searchKey, setSearchKey] = useState("")
  const [listSearchKey, setListSearchKey] = useState([])
  const [showHistory, setShowHistory] = useState(false)
  const { user, setUser } = useAuthContext()

  useEffect(() => {
    let elapsed = 0;
    const maxWaitTime = 10000; // 10 seconds
    const intervalTime = 100; // Check every 100ms

    const checkGigya = setInterval(() => {
      elapsed += intervalTime;

      if (window.gigya?.accounts?.getAccountInfo) {
        console.log('Gigya SDK loaded');
        setIsGigyaReady(true);
        clearInterval(checkGigya);
      } else if (elapsed >= maxWaitTime) {
        console.error('Gigya SDK failed to load within 10 seconds');
        clearInterval(checkGigya);
        // Optionally: setIsGigyaReady(false) or show error to user
      }
    }, intervalTime);

    // Cleanup
    return () => clearInterval(checkGigya);
  }, []);

  useEffect(() => {
    if (isGigyaReady) {
      window.gigya.accounts.getAccountInfo({
        callback: (res) => {
          setUser(res.profile);
        }
      });
    }
  }, [isGigyaReady]);

  const logoutResponse = response => {
    if (response.errorCode == 0) {
      setUser(null)
      navigate("/login/")
    } else {
      alert("Error :" + response.errorMessage)
    }
  }

  const handlerLogout = () => {
    window.gigya.accounts.logout({
      callback: logoutResponse,
    })
  }

  const HandleSearch = () => {
    setShowHistory(false)
    setSearch(!search)
  }

  // MENU - MOBILE
  // Open / close menu state & handler
  const [mobileMenu, setMobileMenu] = useState({
    initial: false,
    clicked: null,
  })
  const [megaMenu, setMegaMenu] = useState(false)
  const handleMenuMobile = () => {
    disabledMenu()
    if (mobileMenu.initial === false) {
      setMobileMenu({ initial: null, clicked: true })
    } else if (mobileMenu.clicked === true) {
      setMobileMenu({ clicked: !mobileMenu.clicked })
    } else if (mobileMenu.clicked === false) {
      setMobileMenu({ clicked: !mobileMenu.clicked })
    }
  }
  // Toggler disabled state & handler
  const [disabled, setDisabled] = useState(false)
  const disabledMenu = () => {
    setDisabled(!disabled)
    setTimeout(() => {
      setDisabled(false)
    }, 1000)
  }
  // Onscroll
  const [navScroll, setNavScroll] = useState(false)
  useEffect(() => {
    const navbar = document.querySelector(".navbar")
    const containsClass = navbar.classList.contains("light")

    window.onscroll = function() {
      if (!containsClass) {
        if (window.pageYOffset > 5) {
          setNavScroll(true)
        } else {
          setNavScroll(false)
        }
      }
    }
  }, [])

  const getSearchKey = () => {
    const savedSearchKeyList = localStorage.getItem("searchKeyObj")
    try {
      const listKey = JSON.parse(savedSearchKeyList)
      setListSearchKey(listKey || [])
    } catch {}
  }

  useEffect(() => {
    getSearchKey()
  }, [])

  const onSearchSubmit = searchKey => {
    const newListKey = listSearchKey.filter(item => item.text !== searchKey)
    newListKey.push({text: searchKey, date: new Date()})
    newListKey.sort((a, b) =>  new Date(b.date) - new Date(a.date))
    localStorage.setItem("searchKeyObj", JSON.stringify(newListKey.slice(0, 3)))
    window.location.replace(
      `${lang === "EN" ? "" : "/id"}/search-result?key=${searchKey}`
    )
  }

  return (
    <>
      <div className="navbar-wrapper fixed-top">
        {/* When giving .navbar-expand-*, don't forget to modify the variables on _navbar.scss */}
        {isAmp ? (
          <>
            <header>
              <amp-mega-menu height="60" layout="fixed-height">
                <nav
                  className={`navbar navbar-expand-${navExpand} transparent dark 
                  ${navScroll ? "is-scrolled" : ""} ${
                    megaMenu ? "nav-menu-active" : ""
                  }`}
                >
                  <ul class="navbar-nav ml-auto">
                    <li>
                      <Link
                        className="navbar-brand"
                        to={lang === "EN" ? "/" : "/id"}
                      >
                        <amp-img
                          src={ImgNavbarLogoDark}
                          class="img-fluid dark"
                          alt="Logo"
                          width="70"
                          height="30"
                        />
                        {/* <amp-img
                          src={ImgNavbarLogoLight}
                          class="img-fluid light"
                          alt="Logo"
                          width="85"
                          height="40"
                        /> */}
                      </Link>
                    </li>
                    <li class="navbar-toggler">
                      <div
                        role="button"
                        on="tap:sidebar1.toggle"
                        tabindex="0"
                        class="hamburger humburger1"
                      >
                        &#x2630;
                      </div>
                    </li>
                    {!user ? (
                      <li class="login-toggler">
                        <Link
                          className="btn btn-secondary pb-1 pt-1 login text-capitalize btn-login"
                          to="/login/"
                        >
                          {lang === "ID" ? "Masuk" : "Login"}
                        </Link>
                      </li>
                    ):(
                      <>
                        <li className={`nav-item`}>
                          <div>
                            <Link className="nav-link" to="/profile/">
                              {lang === "ID" ? "Profil" : "Profile"}
                            </Link>
                          </div>
                        </li>
                        <li className={`nav-item`}>
                          <div>
                            <button
                              className="nav-link"
                              onClick={() => handlerLogout()}
                            >
                              {lang === "ID" ? "Keluar" : "Logout"}
                            </button>
                          </div>
                        </li>
                      </>
                    )}
                  </ul>
                </nav>
              </amp-mega-menu>
            </header>
            <MobileMenu
              mobileMenu={mobileMenu}
              navExpand={navExpand}
              data={data}
              newsSlug={newsSlug}
              isAmp={isAmp}
              isLogin={Boolean(user)}
              handlerLogout={handlerLogout}
            />
          </>
        ) : (
          <>
            <nav
              className={`navbar navbar-expand-${navExpand} transparent dark 
              ${navScroll || disableEffect ? "is-scrolled" : ""} ${
                megaMenu ? "nav-menu-active" : ""
              }`}
            >
              <div className="container position-relative">
                <Link className="navbar-brand" to={lang === "EN" ? "/" : "/id"}>
                  <img
                    src={ImgNavbarLogoDark}
                    className="img-fluid dark"
                    alt="Logo"
                    width="auto"
                  />
                  <img
                    src={ImgNavbarLogoLight}
                    className="img-fluid light"
                    alt="Logo"
                    width="auto"
                  />
                </Link>
                <div className="navbar-toggler">
                  <div className="d-block d-md-none">
                    {/* prettier-ignore */}
                    <button className="nav-link nav-link-icon search-toggler" aria-label="toggler-search" onClick={HandleSearch}>
                      <i className="fal fa-search icon-search" />
                    </button>
                  </div>
                  <button
                    aria-label="toggler-menu"
                    className=""
                    disabled={disabled}
                    onClick={handleMenuMobile}
                  >
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                </div>

                <DesktopMenu
                  navExpand={navExpand}
                  megaMenu={megaMenu}
                  setMegaMenu={setMegaMenu}
                  setNavScroll={setNavScroll}
                  data={data}
                  isLogin={Boolean(user)}
                  handlerLogout={handlerLogout}
                />
                <MobileMenu
                  mobileMenu={mobileMenu}
                  navExpand={navExpand}
                  data={data}
                  newsSlug={newsSlug}
                  handleMenuMobile={handleMenuMobile}
                  isLogin={Boolean(user)}
                  handlerLogout={handlerLogout}
                />
              </div>
            </nav>
            {/* <form
              className={`form-search mobile d-block ${search &&
                "active"} ${search && "is-open"}`}
              onSubmit={e => {
                e.preventDefault()
                onSearchSubmit(searchKey)
              }}
            >
              <ReactSelect
                className="h-30"
                classNamePrefix="select-search"
                options={listSearchKey.map(item => ({
                  label: item,
                  value: item,
                }))}
                placeholder="Search.."
                onChange={value => {
                  setSearchKey(value.label)
                  onSearchSubmit(value.label)
                }}
                onInputChange={text => {
                  setSearchKey(text)
                }}
              />
              <i class="fal fa-times" onClick={HandleSearch}></i>
            </form> */}

            <form
              className={`form-search mobile d-block d-md-none  ${search &&
                "active"}`}
              onSubmit={e => {
                e.preventDefault()
                onSearchSubmit(searchKey)
              }}
            >
              {/* <ReactSelect
                className="h-35 w-100 select-mobile"
                classNamePrefix="select-search"
                options={listSearchKey.map(item => ({
                  label: item,
                  value: item,
                }))}
                placeholder="Search.."
                onChange={value => {
                  setSearchKey(value.label)
                  onSearchSubmit(value.label)
                }}
                onInputChange={text => {
                  setSearchKey(text)
                }}
              /> */}
              <input
                className="form-control"
                name="key"
                id="key"
                type="text"
                placeholder={
                  lang == "EN"
                    ? "Type to search"
                    : "Masukkan kata kunci pencarian"
                }
                onChange={e => {
                  setSearchKey(e.target.value)
                }}
                onFocus={()=>{
                  setShowHistory(true);
                }}
                autoComplete="off"
              />
              {(showHistory && listSearchKey.length) ?
                <ul className="search-history">
                  {listSearchKey.map(item => (
                    <li key={item.text} onClick={()=>onSearchSubmit(item.text)}>
                      <span>{item.text}</span>
                      <time datetime={item.date}>{getDate(item.date, lang)}</time>
                    </li>
                  ))}
                </ul>
              : null}
              <i class="fal fa-times" onClick={HandleSearch}></i>
            </form>
          </>
        )}
      </div>
    </>
  )
}

export default Navbar
